import React, { useState, useEffect } from "react";

import PropTypes from "prop-types";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  MenuItem,
  TextField,
  Grid,
  makeStyles,
} from "@material-ui/core";
import Api from "../../Api";
import api from "../../axios";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

import { useAlert } from "react-alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { AuctionList } from "../../adminModel/auctions";

const useStyles = makeStyles((theme) => ({
  root: {},
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
  dialog: {
    backgroundColor: Api.table.head,
    color: theme.palette.common.white,
  },
}));


const AuctionDetails = ({ className, ...rest }) => {
  const classes = useStyles();
  const alert = useAlert();
  const [banner, setBanner] = useState("");
  // const [cover, setCover] = useState("");

  const [loading, setloading] = useState(false);

  const [values, setValues] = useState("");

  const handleChange =  async(e) => {
    if (e.target.name === "auction_banner") {
    console.log('e.target.files: ',e.target.files[0]);
      setBanner(e.target.files[0]);
    } else {
      /// console.log({ ...values, [e.target.name]: e.target.value })
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };


  
  const [getAuction, setGetAuction] = useState([]);
  const [getId, setGetId] = useState([]);
  useEffect(() => {
    setloading(true)
    async function fetchData() {
      const results = await AuctionList();
      setloading(false)
      // console.log("results",results);
      setGetAuction(results.data);
    }
    fetchData().catch(console.error);
  }, []);

  const handlepick = (e, v) => {
   e.preventDefault();
    try {
      setGetId(v);
      console.log("error",v);
    } catch (error) {
      //  setEventId(v.id);
      setGetId("");
      console.log("error");
    }
    // setEventId(v.id=);
  };



  const handleFormSubmit = (e) => {
    e.preventDefault();


  let formData = new FormData();    

  formData.append('files',banner);
  formData.append('set_id',getId.id)

  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${Api.request.URL}/auction/banner/1`,
    data: formData,
  };

  api
    .request(config)
    .then((response) => {
      alert.success(response.data.msg);
      //return Users();
    })
    .catch((error) => {
      console.log(error);
    });
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={4} md={6} xs={12}>
          <Card style={{ height: "300px" }}>
            <CardContent>
            <div
                                style={{
                                  backgroundImage: `url(${banner ? URL.createObjectURL(banner) : "/static/blank.jpeg"})`,
                                  backgroundColor: "#ffffff",
                                  width: "100%",
                                  height: 270,
                                  display: "inline-block",
                                  backgroundSize: "contain",
                                  backgroundPosition: "center center",
                                  backgroundRepeat: "no-repeat",
                                  // padding: 10,
                                }}
                              ></div>


              {/* <img
                alt="Awsome"
                src={
                  banner ? URL.createObjectURL(banner) : "/static/blank.jpeg"
                }
                style={{ width: "100%", height: "270px" }}
              /> */}
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={8} md={6} xs={12}>
          <form onSubmit={handleFormSubmit}>
            <Card>
              <CardHeader
                subheader="The details can be edited"
                title="Banner and Cover"
              />
              <Divider />
              <CardContent>
                <TextField
                  
                  fullWidth={true}
                  select
                  margin="normal"
                  name="typeImage"
                  label="Select Banner/Cover"
                  onChange={handleChange}
                  variant="outlined"
                >
                  <MenuItem key={1} value={1}>
                    Banner
                  </MenuItem>
                  <MenuItem key={2} value={0}>
                    Cover
                  </MenuItem>
                </TextField>

                <Autocomplete
                  disablePortal
                  style={{ paddingTop: 10 }}
                  id="combo-box-demo"
                  getOptionLabel={(option) =>
                    option ? option.auction_name : ""
                  }
                  onChange={(e, v) => {
                    handlepick(e, v);
                  }}
                  options={getAuction}
                  sx={{ width: 300 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Auction Name"
                      variant="outlined"
                    />
                  )}
                />

                <TextField
                  
                  fullWidth
                  margin="normal"
                  label="Upload Image"
                  name="auction_banner"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  type="file"
                  variant="outlined"
                  // value={banner}
                  onChange={handleChange}
                />
              </CardContent>
              <Divider />
              <Box display="flex" justifyContent="flex-end" p={2}>
                <Button
                  className={classes.importButton}
                  color="primary"
                  variant="contained"
                  type="submit"
                >
                  Upload
                </Button>
              </Box>
            </Card>
          </form>
        </Grid>
      </Grid>

      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

AuctionDetails.propTypes = {
  className: PropTypes.string,
};

export default AuctionDetails;
